import { VisuallyHidden } from '../VisuallyHidden'

/**
 * An invisible period, useful for making screen readers pause between elements
 * without introducing a visible period.
 *
 * For instance, in a box with left- and right-aligned content, a screen reader
 * may read both elements as a single sentence, while they have a clear
 * separation visually. Putting a `ScreenReaderBreak` after the left element
 * will read it as two sentences.
 */
export const ScreenReaderBreak = () => <VisuallyHidden>.</VisuallyHidden>
